import type { AccentHue } from "@repo/fika-design-system/color"
import type { JSXElement } from "solid-js"
import { Box } from "@/designSystem/components/box"
import { buttonContentRecipe } from "./button-drawer.css"

type Props = {
  hue: AccentHue
  leftActions?: JSXElement
  rightActions?: JSXElement
}
export function ButtonDrawer(props: Props) {
  return (
    <Box class={buttonContentRecipe({ hue: props.hue })}>
      <Box
        fill
        gap="12"
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
      >
        <Box gap="12" flexDirection="row" fill>
          {props.leftActions}
        </Box>
        <Box gap="12" flexDirection="row" justifyContent="flex-end" fill>
          {props.rightActions}
        </Box>
      </Box>
    </Box>
  )
}
